import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export function NotFound() {
  const { t } = useTranslation()
  return (
    <main className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center gap-4 p-6">
      <h1 className="text-6xl font-bold">{t('notFound.title')}</h1>
      <p className="text-muted-foreground">{t('notFound.message')}</p>
      <Link to="/" className="text-sm text-primary underline-offset-4 hover:underline">
        {t('notFound.homeLink')}
      </Link>
    </main>
  )
}
